import React, { useCallback, useState, useRef, useMemo, useEffect } from 'react';
import { Grid, Row, Col } from 'antd';
import { useSelector } from 'react-redux';
import indexStyles from '../index.less';
import { localeSelector } from 'src/selector/app';
import { JoinClassName } from 'src/utils/utils';
import Image from 'next/image';
import CommonProductFeatureSection from '../CommonProductFeatureSection';
import FrozenRatio from 'src/components/FrozenRatio/FrozenRatio';
import UnoptimizedImage from 'src/components/UnoptimizedImage';

const { useBreakpoint } = Grid;

const ProudctFeaturies = ({ feature, cardStyle = 'border_card' }) => {
  const screens = useBreakpoint();
  const local = useSelector(localeSelector);
  return (
    <CommonProductFeatureSection
      title={feature.title}
      desc={feature.desc}
      className={indexStyles.max1440Width}
      outerClassName={JoinClassName(
        cardStyle !== 'border_card' ? indexStyles.whiteBackgroundcolor : indexStyles.lightGrayBackgroundcolor
      )}
    >
      <div
        className={JoinClassName(indexStyles.proudctFeaturiesWrapper)}
        style={feature.title ? {} : { marginTop: '0' }}
      >
        <Row align={'middle'} justify={'center'} wrap={true} gutter={[10, { xs: 40, sm: 30, md: 30, lg: 50 }]}>
          {(feature.items || feature).map(
            ({ title, description, cover, coverStyle, coverRatio, direction, items: points }, index) => {
              let showAsReserve = index % 2 !== 0;
              let leftRendAsSubFeature = !title && Array.isArray(points) && points[0].title;
              if (direction) {
                if (direction === 'reverse') {
                  showAsReserve = true;
                } else {
                  showAsReserve = false;
                }
              }

              return (
                <Col xs={24} sm={24} md={24} lg={24} key={index}>
                  <div
                    className={JoinClassName(
                      indexStyles.proudctFeatureWrapper,
                      cardStyle === 'border_card' ? indexStyles.proudctFeatureBorderCard : ''
                    )}
                  >
                    <div
                      className={JoinClassName(indexStyles.proudctFeature, showAsReserve ? indexStyles.reverse : '')}
                    >
                      <div className={JoinClassName(indexStyles.left)} style={coverStyle ? { ...coverStyle } : {}}>
                        <FrozenRatio
                          ratio={
                            cardStyle === 'border_card'
                              ? coverRatio || (leftRendAsSubFeature ? 400 / 640 : 348 / 640)
                              : 360 / 528
                          }
                        >
                          <UnoptimizedImage layout="fill" objectFit="cover" src={`${cover}`} />
                        </FrozenRatio>
                      </div>
                      <div className={JoinClassName(indexStyles.right)}>
                        {title && <h3 className={JoinClassName(indexStyles.proudctFeatureTitle)}>{title}</h3>}
                        {description && <p className={JoinClassName(indexStyles.proudctFeatureDesc)}>{description}</p>}
                        <div className={JoinClassName(indexStyles.proudctFeaturePoints)}>
                          {!leftRendAsSubFeature &&
                            (points || []).map(({ desc }, index) => {
                              return (
                                <span key={index} className={JoinClassName(indexStyles.proudctFeaturePoint)}>
                                  {desc}
                                </span>
                              );
                            })}
                          {leftRendAsSubFeature &&
                            (points || []).map(({ title, desc }, index) => {
                              return (
                                <div className={JoinClassName(indexStyles.asSubFeature)}>
                                  <h3 className={JoinClassName(indexStyles.proudctFeatureTitle)}>{title}</h3>
                                  <span key={index} className={JoinClassName(indexStyles.proudctFeaturePoint)}>
                                    {desc}
                                  </span>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              );
            }
          )}
        </Row>
      </div>
    </CommonProductFeatureSection>
  );
};

export default ProudctFeaturies;
